var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningPendingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60753 12.2492H11.3925C12.2909 12.2492 12.8509 11.275 12.4017 10.4992L8.0092 2.91C7.56003 2.13417 6.44003 2.13417 5.99086 2.91L1.59836 10.4992C1.1492 11.275 1.7092 12.2492 2.60753 12.2492ZM7.00003 8.16583C6.6792 8.16583 6.4167 7.90333 6.4167 7.5825V6.41583C6.4167 6.095 6.6792 5.8325 7.00003 5.8325C7.32086 5.8325 7.58336 6.095 7.58336 6.41583V7.5825C7.58336 7.90333 7.32086 8.16583 7.00003 8.16583ZM7.58336 10.4992H6.4167V9.3325H7.58336V10.4992Z",
    fill: "#F1A809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPendingIcon);
export default __webpack_public_path__ + "static/media/warning_pending_icon.dba6fc91640c27caba6bbd329784c27f.svg";
export { ForwardRef as ReactComponent };